import { render } from "./SwapIcon.vue?vue&type=template&id=6f32cb8f"
const script = {}
script.render = render

export default script